{
  "account-existed-dialog": {
    "buttons": {
      "cancel": "Cancel",
      "login": "Login"
    },
    "text": {
      "title": "There is already an account with these email: {{ email }} or phone number: {{ phoneNr }}",
      "title-email-exists": "There is already an account with these email: {{ email }}",
      "title-phone-exists": "There is already an account with these phone number: {{ phoneNr }}",
      "hint": "You can login directly with this email/phone number or use another email/phone number to register.",
      "hint-email-exists": "You can login directly with this email or use another email to register.",
      "hint-phone-exists": "You can login directly with this phone number or use another phone number to register."
    }
  }
}
